var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearAntiStaticGloves50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35,27c0-0.356,0-11.5,0-11.5c0-0.828-0.672-1.5-1.5-1.5S32,14.672,32,15.5V21l-2-0.167V11.5 c0-0.828-0.672-1.5-1.5-1.5S27,10.672,27,11.5v9.083l-2-0.167V10.5C25,9.672,24.328,9,23.5,9S22,9.672,22,10.5v9.667L20,20v-8.5 c0-0.828-0.672-1.5-1.5-1.5S17,10.672,17,11.5V24c0,0-2.592-3.421-2.615-3.443c-0.701-0.674-1.807-0.753-2.602-0.144 C11.27,20.806,11,21.4,11,22c0,0.254,0.048,0.509,0.146,0.75C11.163,22.792,11.702,24.097,14,29c1.875,4,3,4,3,4l-1,5h18l-1-5 C33,33,35,32,35,27z M25,24c2.209,0,4,1.791,4,4c0,0.741-0.215,1.425-0.566,2.02l-5.454-5.454C23.575,24.215,24.259,24,25,24z M21,28c0-0.741,0.215-1.425,0.566-2.02l5.454,5.454C26.425,31.785,25.741,32,25,32C22.791,32,21,30.209,21,28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearAntiStaticGloves50);
export default __webpack_public_path__ + "static/media/icons8-wear-anti-static-gloves-50.1146e56953e1c1a769020b09e63af471.svg";
export { ForwardRef as ReactComponent };